<template>
  <el-row v-loading="imageLoaded || loadingHeatMap || loadingVisit || loadingThermogram"
          type="flex"
          :gutter="0"
          class="row-content"
          justify="space-between">
    <el-col :span="12">
      <div>
        <transition name="fade">
          <div v-if="floorImage.data" class="neural-switcher">
            <el-switch
                :disabled="!neuralsData"
                v-model="neuralSwitcher"
                active-text="Показать метки нейросети">
            </el-switch>
          </div>
        </transition>

<!--        <div @mouseleave="finishAddingPoints()">-->
        <div>
          <div
              class="ol-map"
              id="map"
              :style="{ 'opacity': imageLoaded ? '0.1' : '1' }"
              ref="map">

            <div ref="popup" class="ol-popup">
              <div ref="popup-content"></div>
            </div>

            <div class="button-panel button-panel_bottom">
              <el-tooltip content="Новое отклонение" placement="top">
                <el-button @click="newZone()"
                           :class="[editMode.enable && editMode.geometryType ==='Polygon' ? 'editor__edit_active' : '']"
                           type=""><i class="el-icon-plus el-icon-right"></i> Новое отклонение
                </el-button>
              </el-tooltip>

              <el-tooltip content="Удалить активную область" placement="top">
                <el-button @click="deleteZone()"
                           :disabled="openZone === false"
                           :class="[editMode.enable && editMode.geometryType ==='Polygon' ? 'editor__edit_active' : '']"
                           type="danger"><i class="el-icon-plus el-icon-delete"></i> Удалить отклонение
                </el-button>
              </el-tooltip>
            </div>
            <div class="button-panel button-panel_right">

              <el-tooltip content="Приблизить изображение" placement="top">
                <el-button @click="clickZoomIn" icon="el-icon-zoom-in" type=""></el-button>
              </el-tooltip>

              <el-tooltip content="Отдалить изображение" placement="top">
                <el-button @click="clickZoomOut" icon="el-icon-zoom-out" type=""></el-button>
              </el-tooltip>

              <el-tooltip content="Режим перемещения" placement="top">
                <el-button @click="toggleInteraction"
                           :type="interactionMove ? 'primary' : ''"
                           icon="el-icon-rank"
                ></el-button>
              </el-tooltip>

            </div>
          </div>

          <transition name="fade">
            <div>
              <div class="btn-control" v-if="openZone !== false">
                <div
                    v-if="editMode.enable"
                    @click="finishAddingPoints()"
                    class="btn-control_btn">
                  Завершить добавление точек
                </div>
                <div
                    v-if="openZone !== false && !editMode.enable"
                    @click="handleModeDrawing(openZone)"
                    class="btn-control_btn">
                  Добавить точки
                </div>

                <el-divider v-if="openZone !== false && !editMode.enable" direction="vertical"></el-divider>
                <div
                    v-if="openZone !== false && !editMode.enable"
                    @click="handleClickDeleteFeature()"
                    class="btn-control_btn">Удалить точку
                </div>
              </div>
              <div class="btn-control" v-if="openZone === false">Область или точка не выбрана</div>
            </div>
          </transition>
        </div>

        <div class="file-name">
          {{ activeFile.data ? 'Оригинальная термограмма id:' + activeFile.id : activeFile.full_title }}
        </div>

        <div class="navigation-tab">
          <hooper :itemsToSlide="2" :itemsToShow="6" v-if="getImages.length !== 0">
            <slide class="navigation-tab__item" v-for="file of getImages" :key="file.id">
              <img @click="selectFile(file)"
                   :src="file.url"
                   :class="['navigation-tab__image', file.id === activeFile.id ? 'navigation-tab__image_active' : '']"
                   width="70">
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
          <el-alert
              v-else
              :closable="false"
              class="noty-alert"
              title="Нет изображений для разметки"
              type="warning"
          />

        </div>
      </div>
    </el-col>
    <el-col :span="12" class="description-box">

      <div v-if="zones.length === 0" class="empty-box">
        <div class="empty-box__title">Вы можете разметить эту карту, для этого:</div>
        <ul class="empty-box__list">
          <li>Нажмите кнопку "Добавить зону <i class="el-icon-plus"></i>"</li>
          <li>Сохдайте области на нужных координатах</li>
          <li>Завершите добавление точек нажав на кнопку "Завершить добавление точек"</li>
          <li>Укажите диагноз новой области или создайте новый</li>
          <li>Для нового диагноза введите формулировку для клиента</li>
          <li>Нажмите кнопку "Сохранить"</li>
        </ul>
      </div>
      <template v-else>
        <div>
          <el-collapse
              accordion
              class="map-description"
              :value="selectedZone ? selectedZone.id : null"
              @input="selectFeatureById">
            <el-collapse-item
                v-for="(dataPoint, item) of zones"
                :name="dataPoint.id"
                :key="item">
              <template slot="title">
                {{ dataPoint | capitalize }}
                <span v-if="!dataPoint.pointId" style="color: rgb(255 131 0)">(Не сохранено)</span>
              </template>
              <description-zone
                  :ref="'zoneItem'+dataPoint.id"
                  :file="activeFile"
                  :point="dataPoint"
                  :device-id="deviceId"
                  :markup-diagnosis-type="markupDiagnosisType"
                  @save="finishAddingPoints"
                  :deviations="deviationField"/>
            </el-collapse-item>
          </el-collapse>

          <div class="comment-block__btns">
            <el-button
                @click="sendComment()"
                type="primary">Сгенерировать комментарий
            </el-button>
          </div>
        </div>

      </template>
    </el-col>
  </el-row>

</template>
<script>
import 'ol/ol.css';
import {mapActions, mapGetters} from "vuex"

import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
} from 'hooper'
import 'hooper/dist/hooper.css'

import Map from 'ol/Map'
import View from 'ol/View'
import {getCenter} from 'ol/extent'
import ImageLayer from 'ol/layer/Image'
import Projection from 'ol/proj/Projection'
import Static from 'ol/source/ImageStatic'
import VectorSource from 'ol/source/Vector'
import {Vector as VectorLayer} from 'ol/layer'
import {defaults as defaultInteractions, Draw, DragPan, MouseWheelZoom} from 'ol/interaction'
import Overlay from 'ol/Overlay'

import Feature from 'ol/Feature'
import {Circle, Fill, Stroke, Style, Text} from 'ol/style'

import Polygon from 'ol/geom/Polygon'
import DescriptionZone from "@/components/HeatMap/DescriptionZones"

export default {
  name: 'HeatMap',
  props: {
    points: {
      required: true,
      default: []
    },
    markup: {
      default: []
    },
    comments: {
      required: true
    },
    deviceId: {
      required: true
    },
    markupDiagnosisType: {},
    planEditorMode: {
      type: String
    },
    deviationField: {
      required: true
    },
    visible: {
      required: true
    },
  },
  components: {DescriptionZone, Hooper, Slide, HooperNavigation},
  filters: {
    capitalize: function (value) {
      return 'Отклонение ' + value.count
    },
    comment(text) {
      return text ? text : 'Комментарий еще не сформирован'
    }
  },
  data() {
    return {
      interactionMove: false,
      neuralSwitcher: false,
      handComment: '',
      isShowComment: false,
      activeCollapse: null,
      map: null,
      imageLayer: null,
      vectorPointsLayer: null,
      source: null,
      neuralSource: null,
      selectedFeature: null,
      openZone: false,
      draw: null,
      imageLoaded: false,
      editMode: {
        enable: false,
        geometryType: '',
      },
      heatPolygons: {},
      activeCompendium: null,
      activeFile: {},
      option: null,
      loading: null,
      options: {},
      zones: [],
      deviations: [],
      sizePoint: 1,
      floorImage: {}
    }
  },
  watch: {
    selectedZone(zone) {
      if (!zone) this.openZone = false; else this.openZone = zone.id
    },
    neuralSwitcher(value) {

      this.vectorNeuralssLayer.setVisible(value)
      // this.vectorPointsLayer.setZIndex(value ? 10 : 0)
      this.redraw()
    },
    floorImage: function (floorImage) {

      // Если нет данных автоматической разметки отключаем переключатель
      if (!this.thermogramNeurals(this.floorImage.id)) {
        this.neuralSwitcher = false
      } else {

        this.neuralsData.polygons.forEach((point, index) => {
          let coods = {
            id: index,
            zone: null,
            coords: [point],
            deviation: this.neuralsData.deviations[index]
          }
          this.addBoundary(coods, true)
        })
      }

      if (!floorImage.url) {
        this.clearFloor()
        this.$notify.error({
          title: "Что-то не так",
          message: "Отсутствует изображение тепловой карты",
        })
      }
    },
    visible(show) {
      if (show) {
        this.loadDictionary()
        this.selectFile(this.getImages[0])
      } else {
        this.finishAddingPoints()
      }
    },
    comments() {
      this.handComment = this.comments.auto_comment
    },
    getZoom(value) {
      this.sizePoint = Math.floor(value) * 2
    },
    markup() {
      this.loadZoneData()
    }
  },
  mounted() {
    this.loadDictionary()
    this.selectFile(this.getImages[0])
  },
  beforeDestroy() {
    this.destroyNativeListeners();
  },
  computed: {
    ...mapGetters({
          loadingHeatMap: "heatMap/loading",
          loadingVisit: "visit/loading",
          loadingThermogram: "thermogram/loading",
          thermogramData: "thermogram/thermograms",
          thermogramNeurals: "thermogram/neurals"
        }
    ),
    neuralsData() {
      return this.thermogramNeurals(this.floorImage.id)
    },
    selectedZone() {
      if (!this.selectedFeature || !this.selectedFeature.get('data')) {
        return null
      }
      return this.zones.find(markedPoint => markedPoint.id === this.selectedFeature.get('data').zone)
    },
    getImages() {
      let files = []
      let dtvs = []

      this.points.files.forEach(field => {
        field.file.forEach(file => {
          if (!this.isImage(file)) {
            dtvs.push(file.id)
            return
          }
          file.visitDiagnosticResultId = field.id
          file.url = this.getUrlPhoto(file.link.get)
          files.push(file)
        })
      })

      this.thermogramData.forEach(thermogram => {

        // if (!this.$refs.dtv) return

        if (!dtvs.includes(thermogram.id)) return

        let canvas = document.createElement('canvas')
        canvas.style.display = "none"

        const ctx = canvas.getContext('2d')
        ctx.canvas.width = thermogram.width
        ctx.canvas.height = thermogram.height
        ctx.putImageData(thermogram.data, 0, 0)
        const file = {
          ...thermogram,
          url: ctx.canvas.toDataURL('image/jpeg'),
          // TODO: check if `visitDiagnosticResultId` needed
        }
        files.push(file)
      })
      return files
    },
    visitId() {
      return this.$route.params.id
    },
    getZoom() {
      if (!this.map) return
      return this.map.getView().getZoom()
    },
  },
  methods: {
    ...mapActions({
      loadDeviation: "heatMap/LOAD_DEVIATION",
      loadVisitData: "visit/LOAD_VISIT_DATA",
    }),
    toggleInteraction() {

      if (this.interactionMove) this.interactionOff()
      else this.interactionOn()

    },
    interactionOn() {
      this.interactionMove = true

      let interactions = defaultInteractions()
      interactions.forEach((interaction) => {
        this.map.addInteraction(interaction);
      })
    },
    interactionOff() {
      this.interactionMove = false

      this.map.getInteractions().forEach(interaction => {
        if (interaction instanceof DragPan)
          this.map.removeInteraction(interaction)

        if (interaction instanceof MouseWheelZoom)
          this.map.removeInteraction(interaction)
      })

    },
    clearOptions() {
      this.options[this.activeCompendium] = []
    },
    editCompendium(data) {
      this.activeCompendium = data;
    },

    isImage(file) {
      return file.ext === "jpeg" || file.ext === "jpg" || file.ext === "png"
    },
    loadBoundaries(points) {
      this.clearPolygons()
      for (let point of points) {
        this.addBoundary(point)
      }
    },
    // O_o
    // Перерисовка стилей
    redraw() {
      if (this.imageLayer) this.imageLayer.getSource().changed()
      if (this.vectorPointsLayer) this.vectorPointsLayer.getSource().changed()
      if (this.map) {
        this.map.renderSync()
        this.map.updateSize()
      }
    },
    // Удаление всех элементов
    clearFloor() {

      const layers = [...this.map.getLayers().getArray()]
      layers.forEach((layer) => this.map.removeLayer(layer))

      this.zones = []
    },
    // Загрузка слоя
    loadFloor(src) {
      this.imageLoaded = true
      let img = new Image()
      let _this = this

      img.onerror = function () {
        _this.$emit('onError')
      };

      img.onload = function () {
        _this.imageLoaded = false

        let extent = [
          0,
          0,
          this.width,
          this.height,
        ];
        let projection = new Projection({
          code: 'pixel',
          units: 'pixels',
          extent: extent,
        });

        if (_this.imageLayer) {
          _this.map.removeLayer(_this.imageLayer)
        }

        _this.imageLayer = new ImageLayer({
          source: new Static({
            url: src,
            projection: projection,
            imageExtent: extent,
            name: 'floorPlanImage'
          }),
        });

        let zoom = 1;
        if (_this.zoom === 0 || _this.zoom) {
          zoom = _this.zoom
        }

        if (_this.map) {
          _this.map.addLayer(_this.imageLayer)
          _this.map.setView(
              new View({
                projection: projection,
                center: getCenter(extent),
                zoom: zoom,
                maxZoom: 6,
              }),
          )
        }
        _this.$emit('onLoad')
      };
      img.src = src;
    },

    clearPolygons() {
      this.source.clear()
      this.neuralSource.clear()
    },
    // Добавление фигуры по координатам
    addBoundary(room, neural) {

      let feature = new Feature({
        geometry: new Polygon(room.coords),
        // title: room.title,
        // compendium: room.compendium,
        // compendium_item: room.compendium_item,
        // compendium_data: room.compendium_data,
      })

      let newPoint = {
        id: feature.ol_uid,
        count: this.zones.length,
        zone: room.zone,
        coords: room.coords,
        deviation: room.deviation,
        // compendium_data: room.compendium_data,
        // visit_diagnostic_result_id: room.visit_diagnostic_result_id,
        deviation_type_id: room.deviation_type_id,
        pointId: room.id,
        neural
      }
      feature.set("data", newPoint)
      if (neural) this.neuralSource.addFeature(feature)
      else this.source.addFeature(feature)

    },
    // Инициализация карты
    initMap() {
      this.source = new VectorSource({features: []})

      // todo сразу добавлять разметку
      this.neuralSource = new VectorSource({features: []})

      this.vectorPointsLayer = new VectorLayer({
        source: this.source,
        style: (feature) => {
          return this.styleFunction(feature)
        },
      })

      this.vectorNeuralssLayer = new VectorLayer({
        source: this.neuralSource,
        style: (feature) => {
          return this.styleFunction(feature)
        },
      })

      const overlay = new Overlay({
        element: this.$refs.popup,
        autoPan: true,
        autoPanAnimation: {
          duration: 250,
        },
      })

      this.vectorPointsLayer.setZIndex(10)
      this.vectorNeuralssLayer.setZIndex(10)
      this.map = null;
      this.map = new Map({
        layers: [this.vectorPointsLayer, this.vectorNeuralssLayer],
        target: this.$refs.map,
        view: new View({
          zoom: this.zoom || 2,
          maxZoom: 5,
        }),
        overlays: [overlay],
        controls: [],
        interactions: defaultInteractions({
          doubleClickZoom: true,
          dragAndDrop: false,
          keyboardPan: true,
          keyboardZoom: true,
          mouseWheelZoom: false,
          pointer: false,
          dragPan: false,
          select: false
        }),
      })

      // Двойнок клик, оставим на всякий случай
      // this.map.on('dblclick', function () {
      // })

      // Нажатие на карту
      this.map.on('click', async (event) => {

        this.selectedFeature = this.map.forEachFeatureAtPixel(event.pixel, function (feature) {
          return feature
        })

        this.vectorPointsLayer.getSource().changed()
        this.vectorNeuralssLayer.getSource().changed()

      })

      // Перемещение курсора по карте
      this.map.on('pointermove', (evt) => {
        if (evt.dragging) return

        const pixel = this.map.getEventPixel(evt.originalEvent);
        const feature = this.map.forEachFeatureAtPixel(pixel, function (feature) {
          return feature
        })

        if (!feature || !feature.get('data')?.neural) return overlay.setPosition(undefined)

        overlay.setPosition(evt.coordinate)

        let text = 'Отклонение от нормы'
        let gradus = feature.get('data').deviation

        let percent = gradus > 0 ? '+' + Math.round(+gradus * 100) : Math.round(+gradus * 100)
        this.$refs['popup-content'].innerHTML = '<p>' + percent + '%</p>' + text + ''
      })

      this.vectorNeuralssLayer.setVisible(false)
    },
    styleFunction(feature) {
      var styles = {};
      var radius = 12;
      let background = '#ffffff7d'

      // Default color
      let border = '#fff'
      let color = '#fff'

      // Выделение группы точек выбранной области
      if (feature.get('data').neural) {
        radius = 12;
        background = this.neuralSwitcher ? 'rgba(0,77,206,0.38)' : 'rgba(255,255,255,0)'

        border = this.neuralSwitcher ? 'rgba(255,0,0,0.49)' : 'rgba(255,255,255,0)'
        color = this.neuralSwitcher ? 'rgba(50,110,230,0.76)' : 'rgba(255,255,255,0)'
      }

      // Выделение группы точек выбранной области
      if (this.selectedZone && feature.get('data').zone === this.selectedZone.id) {
        radius = 12;
        background = 'rgba(50,230,190,0.46)'

        border = '#ffffff7d'
        color = 'rgba(50,230,190,0.76)'
      }

      // Выделение группы точек выбранной точки
      if (this.selectedFeature === feature) {
        radius = feature.get('data').neural ? 0 : 12;
        background = 'rgba(50,230,190,0.76)'
        border = 'rgba(50,230,190,0.76)'
        color = '#fff'
      }

      let image = new Circle({
        radius: radius,
        stroke: new Stroke({color: border}),
        fill: new Fill({color: background}),
      })

      styles['default'] = new Style({
        stroke: new Stroke({
          color: color,
          width: 3,
        }),
        fill: new Fill({color: background}),
        image: image,
        ...(!feature.get('data').neural && {
          text: new Text({
            offsetY: 1,
            font: '15px Arial',
            fill: new Fill({color: '#000'}),
          })
        }),
      })

      let zone = this.zones.find(item => item.id === feature.get('data').zone)

      styles['default'].getText()?.setText(zone.count.toString())
      return styles['default']
    },
    clickZoomIn() {
      this.map.getView().setZoom(this.map.getView().getZoom() + 0.25)
      this.sizePoint = this.sizePoint + 2
    },
    changeZoom(value) {
      if (!this.map) return

      this.map.getView().setZoom(value / 2)
    },
    clickZoomOut() {
      this.map.getView().setZoom(this.map.getView().getZoom() - 0.25)
      this.sizePoint = this.sizePoint - 2
    },
    clickSave() {
      this.$emit('onSavePoints', this.heatPolygons)
    },

    newZone() {
      // Создаем новую область
      if (this.editMode.enable) this.finishAddingPoints()

      let newPoint = {
        id: this.zones.length,
        count: this.zones.length + 1,
        files: [],
      }

      this.zones.push(newPoint)
      this.handleModeDrawing(this.zones.length - 1)

    },
    finishAddingPoints() {
      if (!this.editMode.enable) return
      // if (!this.selectedZone) return

      // this.$refs["zoneItem" + this.selectedZone?.id][0].saveZone(
      //     this.$refs["zoneItem" + this.selectedZone?.id][0].diagnosis,
      //     this.$refs["zoneItem" + this.selectedZone?.id][0].wording
      // )
      this.handleModeDrawing()

    },
    // Добавление точек
    // Переключатель режима рисования
    handleModeDrawing(zone = 0) {
      let geometryFunction = function (coordinates, geometry) {

        let center = coordinates[0];
        let last = coordinates[coordinates.length - 1];
        let dx = center[0] - last[0];
        let dy = center[1] - last[1];

        let newCoordinates = [];
        const radinas = Math.PI / 180;
        for (let angle = 1; angle <= 360; angle++) {
          const px = center[0] + dx * Math.cos(radinas * angle);
          const py = center[1] + dy * Math.sin(radinas * angle);
          newCoordinates.push([px, py]);
        }

        newCoordinates.push(newCoordinates[0].slice());
        if (!geometry) {
          geometry = new Polygon([newCoordinates]);
        } else {
          geometry.setCoordinates([newCoordinates]);
        }
        return geometry
      }

      let geometryType = 'Circle'

      this.map.removeInteraction(this.draw)
      this.draw = new Draw({
        source: this.source,
        type: 'Circle',
        geometryFunction
      });
      this.editMode.enable = this.editMode.geometryType === geometryType ? !this.editMode.enable : true
      this.editMode.geometryType = geometryType

      // Окончание рисования полигона
      this.draw.on('drawend', async (event) => {
        // Получение названия объекта после окончания рисования
        let featureName = event.target.type_

        // Отключение режима рисования
        // this.handleModeDrawing()

        if (featureName === geometryType) {
          // Получение координат объекта после завершения рисования

          let newFile = {
            count: this.zones.length,
            fileId: this.activeFile.id,
            points: []
            // title: 'Отклонение ' + (this.zones.length + 1),
            // compendium: 'disease',
            // compendium_data: [],
            // compendium_deviation: null,
            // compendium_item: []
          }

          let newPoint = {
            coords: event.feature.getGeometry().getCoordinates(),
            id: event.feature.ol_uid,
            zone,
          }

          event.feature.set("data", newPoint)

          this.$nextTick(() => {
            this.selectedFeature = event.feature
            let findIndex = this.findFileIndex(zone, this.activeFile.id)

            // Файл имеется
            if (findIndex + 1) {
              this.zones[zone].files[findIndex].points.push(newPoint)
            } else {
              this.zones[zone].files.push(newFile)
              //
              this.zones[zone].files[this.findFileIndex(zone, this.activeFile.id)].points.push(newPoint)
            }

            this.vectorPointsLayer.getSource().changed()

            // Проверка выхода за границы
            // if (newPoint.coords.x > 1 || newPoint.coords.y > 1 || newPoint.coords.x < 0 || newPoint.coords.y < 0) {
            //   this.handleClickDeleteFeature(newPoint.id)
            // }
          })
        }
      })

      if (this.editMode.enable) this.map.addInteraction(this.draw)
    },
    findFileIndex(zone, fileId) {
      return this.zones[zone].files.findIndex(item => item.fileId === fileId)
    },
    // Удаление активной области
    deleteZone(zoneId = this.openZone) {
      // todo - удаление зоны!!

      if (!this.zones[zoneId].pointId) {
        this.zones.splice(zoneId, 1)
        this.loadDictionary()
        this.selectFile(this.getImages[0])
        return
      }

      this.imageLoaded = true
      this.$api.deviation.rmZone(this.zones[zoneId].pointId).then(() => {

        this.$notify.success({
          title: "Успешно",
          message: "Область удалена",
        })

        this.openZone = false
        this.selectedFeature = null

        // this.zones.splice(zoneId, 1)

        this.loadVisitData({visitId: this.visitId}).then(() => {
          this.loadDictionary()
          this.selectFile(this.getImages[0])
        })

      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка удаления 😕",
          message: response.response.data.message,
        })

      }).finally(() => {
        this.imageLoaded = false
      })

      // const index = this.zones.findIndex(item => item.id === this.selectedZone.id)
      // if (index === -1) return
      //

    },
    // удаление точки из массива
    featureDelete(featureData, findIndex, deleteZone = false) {
      let index = this.zones[featureData.zone].files[findIndex].points.findIndex(item => item.id === featureData.pointId)

      this.zones[featureData.zone].files[findIndex].points.splice(index, 1)
      this.source.removeFeature(this.selectedFeature)
      this.selectedFeature = null

      if (deleteZone) {
        this.deleteZone(featureData.zone)
        // this.zones.splice(featureData.zone, 1)

      } else this.$refs["zoneItem" + featureData.zone][0].saveZone()

    },
    // Удаление точки
    handleClickDeleteFeature() {

      if (!this.selectedFeature) return 0
      const featureData = this.selectedFeature.get('data')

      if (!featureData) return

      let findIndex = this.findFileIndex(featureData.zone, this.activeFile.id)
      if (findIndex === -1) return

      if (this.zones[featureData.zone].files[findIndex].points.length === 1) {

        // Больше нет точек на данном файле проверяем точки отклонения на других файлах
        if (this.zones[featureData.zone].files.length === 1) {
          this.$confirm('Эта точка последняя данного отклонения для всех файлов, удалить отклонение?', 'Удалить отклонение?', {
            confirmButtonText: 'Да',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }).then(() => {
            this.featureDelete(featureData, findIndex, true)
          })
        } else {
          this.featureDelete(featureData, findIndex)
        }
      } else {
        this.featureDelete(featureData, findIndex)
      }

    },

    handleOptionsMarker() {
      if (!this.selectedFeature) {
        return false;
      }
      this.$emit('onOptionsPoint', {
        id: this.selectedFeature.getProperties().id,
        x: this.selectedFeature.getProperties().x,
        y: this.selectedFeature.getProperties().y,
        name: this.selectedFeature.getProperties().name,
      });
    },
    deletePointById(id) {
      const index = this.zones.findIndex(item => item.id === id)
      if (index === -1) return

      this.zones.splice(index, 1)
    },
    initNativeListeners() {
      document.addEventListener('keyup', this._onKeyup)
    },
    destroyNativeListeners() {
      document.removeEventListener('keyup', this._onKeyup)
    },
    _onKeyup(event) {
      event = event || {}

      if (event.key === 'Delete') this.handleClickDeleteFeature()
      if (event.ctrlKey && event.key === 'i') this.handleModeDrawing('Point')
      if (event.key === 'Escape') this.handleModeDrawing();

    },
    selectFeatureById(id) {

      if (id === '') id = false
      this.openZone = id

      this.selectedFeature = this.source.getFeatures().find(feature => feature.get('data').zone === id)
      this.vectorPointsLayer.getSource().changed()
    },
    loadDictionary() {
      // this.loadDeviation()ля клиента • Профиль к
      this.loadZoneData()
    },
    loadZoneData() {
      this.imageLoaded = true
      this.selectedFeature = null

      let zones = this.markup.map(function (item, index) {

        // Переписывание для обратной совместимости
        item.coords.forEach(file => {
          file.points.forEach(point => {
            point.zone = index
          })
        })

        return {
          diagnosis: item.diagnosis,
          count: index + 1,
          id: index,
          pointId: item.id,
          files: item.coords
        }
      })

      this.zones = zones

      if (!this.map) {
        this.initMap()
      }

      this.initNativeListeners()
      this.imageLoaded = false
    },
    reInitSlick() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      });
    },
    next() {
      this.$refs.slick.next()
    },
    selectFile(file) {
      if (!file) return
      this.activeFile = file

      let points = []
      this.zones.forEach((zone) => {
        zone.files.forEach((file) => {
          if (file.fileId === this.activeFile.id) {
            points.push(file.points)
          }
        })
      })

      let coords = []
      points.forEach((points) => {
        points.forEach((coor) => {
          coords.push(coor)
        })
      })

      this.floorImage = file
      this.loadBoundaries(coords)
      this.loadFloor(this.floorImage.url)
    },
    getUrlPhoto(file) {
      return this.$root.getUrlPhoto(file)
    },
    sendComment() {
      this.$emit('onClose')
    },
  }


}
</script>

<style scoped lang="scss">
.row-content {
  padding-top: 25px;
}

.ol-map {
  margin-top: 16px;

  position: relative;
  height: 500px;
  overflow: hidden;
  //width: 542px;

  border: 1px solid #f8f8f8;
  border-radius: 4px;

  @media only screen and (max-width: 1100px) {
    //width: 268px;
  }
}

.editor-panel {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.ol-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  fill: #ffffff;
}

.ol-control-panel {
  position: absolute;
  top: 7px;
  left: 7px;
  z-index: 10;


}

.add-point-control {
  top: 70px;
  left: 8px;
}

.del-point-control {
  top: 100px;
  left: 8px;
}

.button-group {
  margin-left: 10px;
}


.button-panel {
  position: absolute;
  z-index: 10;
  //padding: 5px 24px;
  width: 100%;

  margin: 12px auto;
  border-radius: 4px;

  &_bottom {
    bottom: 0;
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &_right {
    position: absolute;
    z-index: 10;
    right: 12px;
    top: 0;

    width: auto;

    margin: 12px auto;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: end;
    gap: 6px;

    button {
      margin-left: 0;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }


  &__icon {
    margin: 0 10px;
    padding: 5px 0;

    color: #111;
    text-align: center;
    cursor: pointer;

    &:hover {
      color: #258065;
    }
  }
}


.map-description {
  border-top: 0;
  border-bottom: 0;
}

.map-description /deep/ {
  .el-collapse {

  }

  .el-collapse-item__header {
    background: none;
    border-bottom: none;

    white-space: nowrap;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    display: block;
    padding-right: 25px;
  }

  .el-collapse-item__wrap {
    background: none;
    border: none;
  }

  .el-collapse-item {
    background: #EFEFF4;
    border-radius: 4px;

  }

}

.description-box {
  overflow: auto;
  max-height: 667px;
  margin-left: 10px;

}

.comment-block {
  margin-top: 2px;

  &__title {
    margin: 16px 0 8px 0;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;

    color: #111;
  }

  &__textarea /deep/ textarea {
    padding: 10px;

    font-size: 12px;
    line-height: 13px;
    color: #111;


  }

  &__comment {
    word-wrap: break-word;
    word-break: break-word !important;

    font-size: 12px;
    line-height: 13px;

    color: #353535;

    cursor: no-drop;

    border: 1px solid #8e8e93;
    padding: 10px;
    border-radius: 3px;

  }

  &__btns {
    margin-top: 16px;
    float: right;

    &_offset {
      margin-left: 15px;
    }

    *:nth-child(1) {

    }
  }
}

.file-name {
  margin-top: 6px;

  font-weight: 500;
  font-size: 13px;
  line-height: 16px;

  color: #111;
}

.navigation-tab {
  margin-top: 16px;

  &__item {
    width: 74px !important;
    margin-left: 10px;
  }

  &__image {
    display: block;
    width: 70px;
    border-radius: 4px;

    &_active {

      border-radius: 5px;
      box-shadow: 1px 2px 14px #00000026;
      border: 2px #51D6AC solid;
    }
  }
}

/deep/ {
  .hooper {
    height: max-content;

    &:focus {
      outline: -webkit-focus-ring-color auto 0;
    }
  }

  .hooper-list {
    overflow: auto !important;
    width: calc(100% - 90px);
    margin: 0 auto;
    height: 100%;

    /deep/ .hooper-track {
      //overflow-x: hidden;
    }
  }
}


.btn-control {
  width: 100%;
  height: 34px;

  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  padding: 10px;
  margin-bottom: 10px;

  background: #EFEFF4;
  border-radius: 0 0 4px 4px;

  &_btn {
    color: #000;
    cursor: pointer;
    transition: opacity .2s;

    &:hover {
      opacity: 0.5
    }
  }
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.neural-switcher {
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;

  color: #111111;
}

</style>


<style lang="scss">
//.el-collapse-item__header {
//
//}
//
//.el-collapse-item__arrow {
//  position: absolute;
//  right: 0;
//  top: 17px;
//}


.empty-box {
  color: #ccc;
  margin-left: 5px;
  @media screen and (min-width: 1000px) {
    //margin-left: 20px;
  }

  &__title {
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;

    color: #8E8E93;
  }

  &__list {
    word-wrap: break-word;
    word-break: break-word !important;
    margin: 5px 0 0 0;
    padding: 0 0 0 20px;

    font-size: 13px;
    line-height: 16px;


    color: #8E8E93;

    li {
      margin-top: 4px;
    }
  }
}


.ol-popup {
  position: absolute;
  bottom: 12px;
  left: -74px;

  padding: 10px;
  width: 148px;

  background: #D34380;
  border-radius: 1px;

  font-size: 14px;
  color: #fff;

  p {
    font-size: 20px;
    line-height: 20px;
    margin: 4px 0;
  }
}

.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: #D34380;
  border-width: 10px;
  left: 74px;
  margin-left: -10px;
}

</style>
